import { render, staticRenderFns } from "./RewardContent.vue?vue&type=template&id=2e7924e0&scoped=true&"
import script from "./RewardContent.vue?vue&type=script&lang=js&"
export * from "./RewardContent.vue?vue&type=script&lang=js&"
import style0 from "./RewardContent.vue?vue&type=style&index=0&id=2e7924e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7924e0",
  null
  
)

export default component.exports